<h1 mat-dialog-title class="color-blue-cat">Factor Calidad</h1>

<mat-dialog-content class="mat-typography">
  <div *ngIf="factoresDeCalidad.length > 0" style="margin-bottom: 10px;">
    <table mat-table [dataSource]="factoresDeCalidad" class="mat-elevation-z8">
      <ng-container matColumnDef="calidad">
        <th mat-header-cell *matHeaderCellDef>Calidad</th>
        <td mat-cell *matCellDef="let element">{{ element.calidad }}</td>
      </ng-container>
      <ng-container matColumnDef="factor">
        <th mat-header-cell *matHeaderCellDef>Factor</th>
        <td mat-cell *matCellDef="let element">{{ element.factor }}</td>
      </ng-container>
      <ng-container matColumnDef="uso">
        <th mat-header-cell *matHeaderCellDef>Uso</th>
        <td mat-cell *matCellDef="let element">{{ element.uso }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsFactorC"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsFactorC;"></tr>
    </table>
  </div>
  <div class="form-actions">
    <div class="text-right">
      <button mat-raised-button type="button" class="mat-warn" style="color: white;" (click)="closeDialog()">
        Cerrar
      </button>
    </div>
  </div>
</mat-dialog-content>
